<div class="dialog-viewer">
    <h2 mat-dialog-title>Create Waiver</h2>
    <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-dialog-content>
            <div class="row">
                <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col">
                        <mat-form-field>
                            <mat-label>Title</mat-label>
                            <input matInput formControlName="title" required>
                            <mat-error *ngIf="form.get('title').errors?.required">Title is required</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <ejs-richtexteditor id='editor' [toolbarSettings]='toolbarItems' formControlName="legalTerms"
                            height="400px" [pasteCleanupSettings]='pasteCleanupSettings'>
                        </ejs-richtexteditor>
                        <mat-error *ngIf="form.get('legalTerms').errors?.required">Legal Terms is required</mat-error>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <mat-slide-toggle formControlName="isActive">Active</mat-slide-toggle>
                        <mat-error *ngIf="form.get('isActive').errors?.validationErrors">
                            {{ form.get("isActive").errors?.validationErrors}}
                        </mat-error>
                    </div>
                </div>
            </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-button type="button" (click)="dialogRef.close()">Cancel</button>
            <button mat-raised-button type="submit" [disabled]="!form.valid || isLoading">Save</button>
        </mat-dialog-actions>
    </form>
</div>